import { CloseSnackBar } from "event-definitions"
import { defer } from "lib/defer"
import { snackbar } from "lib/snackbar"
import { ShareLinkDownloadProgressSnackbar } from "./share-link-download-progress-snackbar"

export async function waitForShareLinkDownload({ result, message, snackbarKey, dataEvent }) {
    if (result !== "WaitForEvent") {
        return result
    }

    const promise = defer()
    snackbar(<ShareLinkDownloadProgressSnackbar message={message} snackbarKey={snackbarKey} />, {
        variant: "info",
        persist: true,
        key: snackbarKey,
    })

    dataEvent.once(handleData)
    return promise

    function handleData(payload) {
        CloseSnackBar.raiseLater(snackbarKey)
        if (payload.error) {
            promise.reject(payload.error)
            return
        }
        promise.resolve(payload.data)
    }
}
